import { isEmpty, isNil, upperCase } from "lodash"
import { IPushCoachEventsParams } from "../interfaces/api/sms/pushCoachEvents"
import { v4 as uuidv4 } from "uuid"
import { EventNames } from "../constants/eventNames"
import { store } from "../reducers/rootReducer"
import { getConsultationType } from "./helpers"
import { ApiManager } from "../api/ApiManager"

export enum UserChannelEvent {
	TRIGGER_BATCH = "TRIGGER_BATCH",
	CLEAR_EVENTS = "CLEAR_EVENTS",
	SEND_EVENTS = "SEND_EVENTS",
}

export const REMOVE_SESSION_DATA = "REMOVE_SESSION_DATA"

export const triggerEvents = async (action?: string) => {
	const events = sessionStorage.getItem("events")

	try {
		const payload = JSON.parse(events)
		if (!isEmpty(payload)) {
			await ApiManager.getSubscriptionManagerApis().pushCoachEvents(payload)
			clearEvents()
		}
		if (action === "REMOVE_SESSION_DATA") {
			removeAppSession()
		}
	} catch (error) {
		console.error("triggerEvents: ", error)
	}
}

export const clearEvents = () => {
	sessionStorage.setItem("events", JSON.stringify([]))
}

export const pushEvent = (data: IPushCoachEventsParams) => {
	const events = sessionStorage.getItem("events")
	if (isEmpty(events) || isNil(events)) {
		sessionStorage.setItem("events", JSON.stringify([data]))
	} else {
		const eventsArray = JSON.parse(events)
		eventsArray.push(data)
		sessionStorage.setItem("events", JSON.stringify(eventsArray))
	}
}

export const createAppSession = () => {
	const sessionId = uuidv4()
	sessionStorage.setItem("session-id", sessionId)
	localStorage.removeItem("synapse-sessions-list")

	const currentSessions = localStorage.getItem("synapse-sessions-list-v2")
	if (isEmpty(JSON.parse(currentSessions))) {
		localStorage.setItem("synapse-sessions-list-v2", JSON.stringify([sessionId]))
	} else {
		const sessionsArray = JSON.parse(currentSessions)
		sessionsArray.push(sessionId)
		localStorage.setItem("synapse-sessions-list-v2", JSON.stringify(sessionsArray))
	}
	return sessionId
}

export const removeAppSession = () => {
	const sessionId = sessionStorage.getItem("session-id")
	const currentSessions = localStorage.getItem("synapse-sessions-list-v2")
	const sessionsArray = JSON.parse(currentSessions)
	const index = sessionsArray.findIndex((session: string) => session === sessionId)
	sessionsArray.splice(index, 1)
	localStorage.setItem("synapse-sessions-list-v2", JSON.stringify(sessionsArray))
}

export const getURLChangeEvent = (agentId: string | number, sessionId: string, location: string): IPushCoachEventsParams => {
	const userId = store?.getState()?.patientData?.patientDetails?.curefitUserId
	return {
		activityTime: new Date().getTime(),
		agentId: agentId,
		eventType: "START",
		name: EventNames.PAGE_URL_CHANGE,
		sessionId: sessionId,
		userId: userId,
		widgetId: location,
	}
}

export const getEventPayload = (eventData: Partial<IPushCoachEventsParams>): IPushCoachEventsParams => {
	const sessionId = sessionStorage.getItem("session-id")
	const agentId = store?.getState()?.accountData?.agentId
	const agentEmail = store?.getState()?.accountData?.email
	const userId = store?.getState()?.patientData?.patientDetails?.curefitUserId
	const location = window.location.pathname
	if ((!!agentId || !!agentEmail) && !!sessionId) {
		return {
			...eventData,
			activityTime: new Date().getTime(),
			eventType: "START",
			sessionId: sessionId,
			agentId: agentId || agentEmail,
			userId: eventData?.userId || userId,
			widgetId: location,
		} as IPushCoachEventsParams
	}
}

export const generateEventAndPush = (eventData: Partial<IPushCoachEventsParams>) => {
	const event = getEventPayload(eventData)
	if (event?.name) {
		const consultationPrefix = getConsultationType()
		if (!!consultationPrefix) {
			const { childWidgets, ...restParams } = { ...(store?.getState()?.coachConsultation?.openedTab || {}) }
			if (!isEmpty(restParams)) {
				event.metadata = { ...(event.metadata || {}), ...restParams }
			}
		}
		event.name = `${consultationPrefix ? consultationPrefix + "__" : ""}${event.name}`.substring(0, 128)
		pushEvent(event)
	}
}

export const convertToEventName = (word: string) => {
	if (!word) return ""
	return upperCase(word).split(" ").join("_")
}
